import { PaginateHelper } from 'Guide/paginate_helper';

onDomReady(() => {
   const elem = document.querySelector('#activityTimeLimit');
   if (elem) {
      elem.addEventListener('change', () => {
         window.location = elem.options[elem.selectedIndex].value;
      });
   }

   document.querySelectorAll('.filterOption').forEach(option => {
      option.addEventListener('click', () => {
         option.classList.add('selectedButton');
         // It's possible to click the list item, but not the link,
         // so redirect with JS to act more like a button.
         window.location = option.querySelector(':scope > a').getAttribute('href');
      });
   });

   const toggleClass = (el, className) => {
      if (!el) {
         return;
      }

      if (el.classList) {
         el.classList.toggle(className);
         return;
      }

      const classes = el.className.split(' ');
      const existingIndex = classes.indexOf(className);

      if (existingIndex === -1) {
         classes.push(className);
      } else {
         classes.splice(existingIndex, 1);
      }

      el.className = classes.join(' ');
   };

   const toggleTab = tabEl => {
      const tabName = tabEl.dataset.tab;

      const tabContent = document.querySelector(`.js-tab-content.${tabName}`);
      toggleClass(tabEl, 'active');
      toggleClass(tabContent, 'hidden');
   };

   const tabs = document.querySelectorAll('.tab-link:not([href])');

   const pushTabToHistory = (tabEl, urlOverride, isReplace) => {
      const dataurl = tabEl.dataset.url;
      const hasState = dataurl || urlOverride === dataurl;

      if (hasState) {
         const url = urlOverride || dataurl;
         const urlWithHash = url + window.location.hash;
         const histFunc = isReplace ? history.replaceState : history.pushState;
         histFunc.call(history, { activeTabId: tabEl.id }, '', urlWithHash);
      }
   };

   window.addEventListener('popstate', event => {
      const state = event.state;
      if (state) {
         const tabEl = document.getElementById(state.activeTabId);
         setActiveTab(tabEl);
      }
   });

   const getActiveTab = () => document.querySelector('.tab-link.active');

   const setFilterSelectOption = () => {
      const filterSelect = document.querySelector('#filterOptionSelect');

      if (!filterSelect || getComputedStyle(filterSelect).display === 'none') {
         return;
      }
      const path = window.location.pathname;
      const sanatizedPath = path.replace(/"/g, '\\"');
      const option = document.querySelector(
         `#filterOptionSelect option[value="${CSS.escape(sanatizedPath)}"]`
      );
      if (option) {
         filterSelect.value = path;
      }
   };

   const setActiveTab = tabEl => {
      const activeTab = getActiveTab();

      toggleTab(tabEl);
      toggleTab(activeTab);
   };

   const activeTab = getActiveTab();
   pushTabToHistory(activeTab, window.location.pathname, true);
   setFilterSelectOption();

   const onClickTab = e => {
      const clickedTab = e.target;
      const activeTab = getActiveTab();

      const isSameTab = clickedTab.isSameNode(activeTab);
      if (isSameTab) {
         return;
      }

      setActiveTab(clickedTab);

      pushTabToHistory(clickedTab);

      e.preventDefault();
      e.stopPropagation();
   };

   tabs.forEach(el => {
      el.addEventListener('click', onClickTab);
   });

   if (document.getElementById('pagekey')) {
      let mainContent = new PaginateHelper({
         container: 'content',
         contentPath: ({ pagekey, type, page, limit }) =>
            type === 'teamActivity'
               ? `teams/${pagekey}/activity/html?${new URLSearchParams({
                    page,
                    limit: limit ?? 'last_three_days',
                 })}`
               : `teams/${pagekey}/contributions/${type}/html?page=${page}`,
      });
   }
});
